import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const StatsSection = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const [counts, setCounts] = useState({ years: 0, clients: 0, team: 0, support: 0 });

  useEffect(() => {
    if (inView) {
      const duration = 2000;
      const steps = 60;
      const interval = duration / steps;

      const targets = { years: 12, clients: 500, team: 8, support: 24 };

      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;

        setCounts({
          years: Math.floor(targets.years * progress),
          clients: Math.floor(targets.clients * progress),
          team: Math.floor(targets.team * progress),
          support: Math.floor(targets.support * progress),
        });

        if (step >= steps) {
          setCounts(targets);
          clearInterval(timer);
        }
      }, interval);

      return () => clearInterval(timer);
    }
  }, [inView]);

  const stats = [
    { value: counts.clients, suffix: '+', label: 'Mutlu Müşteri' },
    { value: counts.team, suffix: '', label: 'Kişilik Ekip' },
    { value: counts.support, suffix: '/7', label: 'Saat Destek' },
  ];

  return (
    <section ref={ref} className="bg-white py-12 md:py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-3 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center relative">
              <div className="text-3xl md:text-5xl lg:text-6xl font-bold text-wood-dark mb-2 md:mb-3">
                {stat.value}
                <span className="text-wood">{stat.suffix}</span>
              </div>
              <div className="text-xs md:text-base lg:text-lg text-wood font-medium">{stat.label}</div>
              {index < stats.length - 1 && (
                <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-16 bg-wood/20"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
